<template>
  <div :class="{ 'mt-30-px': !showNavbar }">
    <notifications></notifications>
    <navbar
      v-if="showNavbar"
      :docsName="docsName"
    />

    <ValidationObserver v-slot="{ invalid }">
      <div class="container-fluid row">
        <div
          v-if="showNavbar"
          class="col-xl-12"
        >
          <div class="row">
            <div class="col-xl-12 block br-t-l-0 mb-3">
              <head-menu
                :col="12"
                class="d-xl-flex"
                :headline="navbarTitel"
              ></head-menu>
              <div class="row mt-2 d-flex justify-content-between">
                <div class="ml-4">
                  <button
                    v-shortkey.once="['ctrl', 's']"
                    class="btn btn-success mr-2"
                    :disabled="invalid"
                    @click="speichern"
                    @shortkey="speichern"
                  >
                    {{ $t('global.save') }}
                  </button>
                  <button
                    class="btn btn-primary mr-2"
                    @click="abbrechen"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-list"
                      class="mr-2"
                    />
                    {{ $t('global.tolist') }}
                  </button>
                </div>
                <div class="mr-4">
                  <button
                    class="btn btn-danger"
                    @click="oeffneLoeschenModal"
                    v-if="berechtigungen.m_umfragen.delete && editable"
                  >
                    <font-awesome-icon icon="fa-duotone fa-trash" />
                    <span>{{ $t('global.delete') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- START Linke Seite -->
        <div
          class="col-xl-12 pr-3"
          :class="{ 'col-xl-12': !showNavbar }"
        >
          <!-- START Daten -->
          <container-headline
            :headline="$t('global.masterdata')"
            :col="2"
          ></container-headline>
          <div class="row mb-3">
            <div class="col-xl-12 block br-t-l-0">
              <div class="eingabe-panel-kopf p-3">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <ValidationProvider
                        rules="required"
                        immediate
                        v-slot="{ passed }"
                      >
                        <input
                          v-model="modul.bezeichnung"
                          v-bind:class="{ 'border-danger': !passed }"
                          class="form-control"
                          :readonly="!editable"
                        />
                        <label v-bind:class="{ 'text-danger': !passed }">
                          {{ $t('global.designation') }}
                        </label>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <v-select
                        v-model="modul.noteneingabe_typ"
                        class="w-100"
                        label="bezeichnung"
                        :options="noteneingabetypen"
                        :disabled="!editable"
                      >
                        <span slot="no-options">
                          {{ $t('global.taptosearch') }}
                        </span>
                      </v-select>
                      <!-- TODO: add translation -->
                      <label>Noteneingabetyp</label>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <!-- TODO: add translation -->
                    <div
                      class="form-group"
                      v-if="modul.noteneingabe_typ.bezeichnung === 'Punkte'"
                    >
                      <v-select
                        v-model="modul.anzeigemodus"
                        class="w-100"
                        label="bezeichnung"
                        :options="anzeigemodus_werte"
                        :disabled="!editable"
                      >
                        <span slot="no-options">
                          {{ $t('global.taptosearch') }}
                        </span>
                      </v-select>
                      <!-- TODO: add translation -->
                      <label>Anzeigemodus</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <div class="input-group">
                        <input
                          class="form-control"
                          v-model="modul.schwellenwert"
                          :readonly="!editable"
                        />
                      </div>
                      <!-- TODO: add translation -->
                      <label>Schwellenwert</label>
                    </div>
                  </div>
                  <div class="col-xl-2">
                    <div class="form-group">
                      <input
                        class="form-control"
                        v-model="modul.cp"
                        :readonly="!editable"
                      />
                      <!-- TODO: add translation -->
                      <label>CP</label>
                    </div>
                  </div>
                  <div class="col-xl-2">
                    <div
                      class="form-group d-flex justify-content-center align-items-center"
                    >
                      <b-form-checkbox
                        v-model="modul.dynamische_vergabe"
                      ></b-form-checkbox>
                      <!-- TODO: add translation -->
                      <label>Dynamische Vergabe</label>
                    </div>
                  </div>
                  <div
                    class="col-xl-2"
                    v-if="modul.dynamische_vergabe"
                  >
                    <div class="form-group">
                      <div class="input-group">
                        <input
                          class="form-control"
                          v-model="modul.cp_min"
                          :readonly="!editable"
                        />
                      </div>
                      <!-- TODO: add translation -->
                      <label>Minimum CP</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <unsaved-changes-modal
        @discard="handleDiscard"
        @stay="handleStay"
        :saveFunction="invalid == true ? null : speichern"
      />
    </ValidationObserver>

    <loading-overlay v-show="loading"></loading-overlay>

    <loeschen-modal
      id="modul-loeschen-modal"
      @confirmed="modulLoeschen"
    />
  </div>
</template>

<script>
  import HeadMenu from '@/components/HeadMenu'
  import ContainerHeadline from '@/components/ContainerHeadline'
  import Navbar from '@/components/Navbar'
  import { apiErrorToAlert } from '@/utils/Errorhandler'
  import AppApi from '@/api/AppApi'
  import store from '@/store'
  import page from '@/mixins/Page'
  import ChangeWatcherNew from '@/mixins/ChangewatcherNew'
  import UnsavedChangesModal from '@/components/Modals/UnsavedChangesModal.vue'
  import LoeschenModal from '@/components/Modals/LoeschenModal'
  import { LADE_AUSWAHLWERTE_NOTEN } from '@/store/noten/actions.type'
  import { LADE_AUSWAHLWERTE_MODULUNTERRICHT } from '@/store/modulunterricht/actions.type'

  export default {
    name: 'modul',
    components: {
      HeadMenu,
      Navbar,
      ContainerHeadline,
      LoeschenModal,
      UnsavedChangesModal,
    },
    mixins: [page, ChangeWatcherNew],
    store,
    props: {
      id: {
        type: String,
        default: null,
      },
      anzeige: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        editable: true,
        modul: {
          id: null,
          bezeichnung: null,
          dynamische_vergabe: false,
          cp: null,
          cp_min: null,
          noteneingabe_typ: {
            id: null,
            bezeichnung: null,
          },
          anzeigemodus: {
            id: null,
            bezeichnung: null,
          },
          schwellenwert: null,
        },
      }
    },
    computed: {
      queryParams: function () {
        var params = {
          page: this.page,
          count: this.anzahlProPage,
        }
        return params
      },

      navbarTitel: function () {
        if (this.id) {
          // TODO: change variable
          return 'Modul'
        } else {
          return 'Neues Modul'
        }
      },
      noteneingabetypen: {
        get() {
          return this.$store.state.noten.noteneingabetypen
        },
      },
      anzeigemodus_werte: {
        get() {
          return this.$store.state.modulunterricht.anzeigemodus
        },
      },
    },
    watch: {},
    created() {
      this.loading = true
      if (this.id) this.loadModul()
      this.loading = false
    },
    mounted() {
      // load textwahlwerte
      this.$store.dispatch(`noten/${LADE_AUSWAHLWERTE_NOTEN}`)
      this.$store.dispatch(
        `modulunterricht/${LADE_AUSWAHLWERTE_MODULUNTERRICHT}`
      )
    },
    methods: {
      async loadModul() {
        if (this.id) {
          // TODO: update path
          await AppApi.get('modul/', {
            params: { id: this.id },
          }).then((response) => {
            this.initializeModul(response.data)
            this.loading = false
          })
        }
      },

      abbrechen() {
        this.$router.push({ name: 'einstellungen-moduleliste' })
      },

      initializeModul(modul) {
        if (modul) {
          this.modul = modul
        } else {
          console.error('modul ist null')
        }
      },

      speichern() {
        if (this.loading) return
        this.loading = true
        var json = this.modul
        if (!this.id) {
          // TODO: update path
          AppApi.post('modul/', json)
            .then((response) => {
              this.initializeModul(response.data)
              this.$notify({
                type: 'success',
                title: this.$t('global.actionsuccessful'),
                // TODO: update translated value
                text: this.$t('global.modulsavedsuccessfully'),
              })

              this.$router.replace({
                name: 'einstellungen-modul',
                params: { id: response.data.id, anzeige: 0 },
              })
            })
            .catch((e) => {
              this.$notify(apiErrorToAlert(e))
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          // TODO: update path
          AppApi.put('modul/', json)
            .then((response) => {
              this.loadModul()
              this.$notify({
                type: 'success',
                title: this.$t('global.actionsuccessful'),
                // TODO: update translated value
                text: this.$t('global.modulsavedsuccessfully'),
              })
            })
            .catch((e) => {
              this.$notify(apiErrorToAlert(e))
            })
            .finally(() => {
              this.loading = false
            })
        }
      },

      oeffneLoeschenModal() {
        this.$bus.$emit('openLoeschenModal', 'modul-loeschen-modal')
      },

      modulLoeschen() {
        AppApi.delete('modul/', { data: [this.id] })
          .then(() => {
            this.$router.push({ name: 'einstellungen-moduleliste' })
          })
          .catch((e) => {
            this.$notify({
              type: 'warn',
              title: this.$t('global.actionfailed'),
              // TODO: add translation
              text: this.$t('global.modulcouldnotbedeleted'),
            })
          })
      },
    },
  }
</script>

<style></style>
